import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private api = inject(ApiService);

  list(scope: string | 'all' = 'all') {
    const path = scope === 'all' ? '/user' : `/user/${scope}`;
    return this.api.get(path);
  }
  upsert(json: any) { return this.api.post('/user', json); }
  remove(id: number) { return this.api.get(`/user/remove/${id}`); }
  createUsersStudios(json: any) { return this.api.post('/user/studio/create', json); }
  getUsersStudios(scope: any) { return this.api.get(`/user/studio/${scope}`); }
  getKeyNumber(scope: any) { return this.api.get(`/keyNumber/user/${scope}`); }
  getStudio(userId: number | string) { return this.api.get(`/user/${userId}/studio`); }
  clearUsersStudios(scope: any) { return this.api.get(`/user/studio/remove/${scope}`); }
}
